export default __webpack_public_path__ + "static/media/Knight.7bacafc4.svg";